{
  "name": "esri-leaflet",
  "description": "Leaflet plugins for consuming ArcGIS Online and ArcGIS Server services.",
  "version": "2.1.3",
  "author": "Patrick Arlt <parlt@esri.com> (http://patrickarlt.com)",
  "browser": "dist/esri-leaflet-debug.js",
  "bugs": {
    "url": "https://github.com/esri/esri-leaflet/issues"
  },
  "contributors": [
    "Patrick Arlt <parlt@esri.com> (http://patrickarlt.com)",
    "John Gravois <jgravois@esri.com> (http://johngravois.com)"
  ],
  "dependencies": {
    "@esri/arcgis-to-geojson-utils": "^1.0.5",
    "leaflet-virtual-grid": "^1.0.5",
    "tiny-binary-search": "^1.0.2"
  },
  "devDependencies": {
    "chai": "3.5.0",
    "gh-release": "^2.0.0",
    "highlight.js": "^8.0.0",
    "http-server": "^0.10.0",
    "husky": "^0.12.0",
    "isparta": "^4.0.0",
    "istanbul": "^0.4.2",
    "karma": "^1.7.0",
    "karma-chai-sinon": "^0.1.3",
    "karma-chrome-launcher": "^2.2.0",
    "karma-coverage": "^1.1.1",
    "karma-mocha": "^1.3.0",
    "karma-mocha-reporter": "^2.2.1",
    "karma-sourcemap-loader": "^0.3.5",
    "mkdirp": "^0.5.1",
    "mocha": "^3.4.2",
    "npm-run-all": "^4.0.2",
    "phantomjs": "^1.9.8",
    "rollup": "^0.25.4",
    "rollup-plugin-json": "^2.3.0",
    "rollup-plugin-node-resolve": "^1.4.0",
    "rollup-plugin-uglify": "^0.3.1",
    "semistandard": "^9.0.0",
    "sinon": "^1.11.1",
    "sinon-chai": "2.8.0",
    "snazzy": "^5.0.0",
    "uglify-js": "^2.8.29",
    "watch": "^0.17.1"
  },
  "homepage": "http://esri.github.io/esri-leaflet",
  "module": "src/EsriLeaflet.js",
  "jsnext:main": "src/EsriLeaflet.js",
  "jspm": {
    "registry": "npm",
    "format": "es6",
    "main": "src/EsriLeaflet.js"
  },
  "keywords": [
    "arcgis",
    "esri",
    "esri leaflet",
    "gis",
    "leaflet plugin",
    "mapping"
  ],
  "license": "Apache-2.0",
  "main": "dist/esri-leaflet-debug.js",
  "peerDependencies": {
    "leaflet": "^1.0.0"
  },
  "readmeFilename": "README.md",
  "repository": {
    "type": "git",
    "url": "git@github.com:Esri/esri-leaflet.git"
  },
  "scripts": {
    "build": "rollup -c profiles/debug.js & rollup -c profiles/production.js",
    "lint": "semistandard | snazzy",
    "prebuild": "mkdirp dist",
    "prepublish": "npm run build",
    "pretest": "npm run build",
    "precommit": "npm run lint",
    "release": "./scripts/release.sh",
    "start-watch": "watch \"npm run build\" src",
    "start": "run-p start-watch serve",
    "serve": "http-server -p 5000 -c-1 -o",
    "test": "npm run lint && karma start",
    "test:ci": "npm run lint && karma start --browsers Chrome_travis_ci"
  },
  "semistandard": {
    "globals": [
      "expect",
      "L",
      "XMLHttpRequest",
      "sinon",
      "xhr",
      "proj4"
    ]
  }
}
